export default __webpack_public_path__ + "static/media/icon2.9dbfe5f3.png";